import { usePathname } from 'next/navigation'
import React from 'react'
import { IconName } from 'src/types/generated-icons'

import { IconSprite } from '@/components/IconSprite'
import cn from '@/utils/cn'

import allRoutes from 'all-routes.json'

type IconProps = {
  name: IconName
  className?: string
}

export type IconsNames = IconName

const Icon: React.FC<IconProps> = ({ name, className }) => {
  const pathname = usePathname() || ''

  function getSpriteNameFromPath(path: string) {
    if (!path || typeof path !== 'string') return '404 - page not found'

    return path
      .replace(/^\/|\/$/g, '')
      .replace('/index.html', '')
      .replace('.html', '')
  }

  const spriteFilename = getSpriteNameFromPath(pathname)

  function getSafeSpriteName() {
    if (!spriteFilename) return 'index'

    const exists = allRoutes.find(
      (route) => getSpriteNameFromPath(route) === spriteFilename
    )

    return exists ? spriteFilename : 'index' // handle rewrite to home when access other pages
  }

  const sprite = getSafeSpriteName()

  return (
    <IconSprite
      name={name}
      className={cn('max-w-full max-h-full w-24 h-24 min-w-[24px]', className)}
      spriteName={`sprites/${sprite}`}
    />
  )
}

export default Icon
